export default __webpack_public_path__ + "static/media/mrle-interie.a24d294b.jpg";